/**
 * Creates a new marker and LatLng object with the specified latitude, longitude, title, and Google Maps API objects.
 */
export const newMarkerAndLatLng = ({ lat, lng, title, maps, map, }) => {
    const position = { lat, lng };
    return {
        position,
        marker: new maps.marker.AdvancedMarkerElement({
            position,
            map,
            title,
        }),
    };
};
